/**
 * Edit Controller
 */
(function(angular) {
  'use strict';

  var app = angular.module('asDemandMgr'),
    generatePie,
    generateSerial;

  app.controller('OverviewController', [
    '$scope',
    'overviewApi',
    'optionsApi',
    function($scope, overviewApi, optionsApi) {
      $scope.showPie = false;
      $scope.showSerial = true;
      $scope.showCampaigns = true;
      $scope.showCreatives = true;
      $scope.showUpcoming = true;

      $scope.data = {
        pie: [],
        line: [],
        campaigns: [],
        creatives: [],
        upcoming: [],
      };

      $scope.campaignsData = [];

      $scope.creativesPage = {
            number: 0,
            size: 10,
      };

      $scope.drill = function(url) {
        window.location.href = url;
      };


      $scope.ranges = [
        {
          name: 'This Week',
          value: 'this_week',
        },
        {
          name: 'Last 7 Days',
          value: 'last_7_days',
        },
        {
          name: 'Last Week',
          value: 'last_week',
        },
        {
          name: 'Last 14 Days',
          value: 'last_14_days',
        },
        {
          name: 'Last 2 Weeks',
          value: 'last_2_weeks',
        },
        {
          name: 'This Month',
          value: 'this_month',
        },
        {
          name: 'Last 30 Days',
          value: 'last_30_days',
        },
        {
          name: 'Last Month',
          value: 'last_month',
        },
      ];

      var fetchFilterOptions = function() {

        overviewApi.getAdvertisers().then(function(res) {
          $scope.advertisers = [
            {
              value: '*',
              name: 'All Advertisers',
            },
          ];

          res.data.forEach(function(advertiser) {
            $scope.advertisers.push({
              value: advertiser._id,
              name: advertiser.name,
            });
          });
        });

        overviewApi
          .getIos($scope.filters.advertiser)
          .then(function(res) {
            $scope.ios = [
              {
                value: '*',
                name: 'All Insertion Orders',
              },
            ];

            res.data.forEach(function(io) {
              $scope.ios.push({
                value: io._id,
                name: io.name,
              });
            });
          });

        overviewApi
          .getCampaigns(
            $scope.filters.advertiser,
            $scope.filters.io
          )
          .then(function(res) {
            $scope.campaigns = [
              {
                value: '*',
                name: 'All Campaigns',
              },
            ];

            res.data.forEach(function(campaign) {
              $scope.campaigns.push({
                value: campaign._id,
                name: campaign.name,
              });
              $scope.campaignsData[campaign._id] = campaign;
            });
            if (preselectedCids && preselectedCids.length > 0) {
                $scope.campaigns.sort(function (a,b){
                    return (preselectedCids.indexOf(a.value) != -1) ? -1 : (preselectedCids.indexOf(b.value) != -1) ? 1 : 0;
                });
            }

              // load data after campaigns load
            fetchData();
            $scope.fetchCreatives();
          });
      };


        var yyyymmdd  = function(x) {
            var y = x.getFullYear().toString();
            var m = (x.getMonth() + 1).toString();
            var d = x.getDate().toString();
            (d.length == 1) && (d = '0' + d);
            (m.length == 1) && (m = '0' + m);
            var yyyymmdd = y + m + d;
            return yyyymmdd;
        }

      var fetchData = function() {
        $scope.loading = true;

        overviewApi
          .getUpcoming(
            $scope.filters.range,
            $scope.filters.advertiser,
            $scope.filters.io,
            $scope.filters.campaign
          )
          .then(
            function(res) {
              $scope.upcoming = [];
              if (res.length > 0) {
                $scope.upcoming = res;
              }
            },
            function() {
              console.error('Error while fetching data');
            }
          );

        if (optionsApi.isUseCdp()) {
            overviewApi
                .getDeliveredCampaigns(
                    $scope.filters.range,
                    $scope.filters.advertiser,
                    $scope.filters.io,
                    $scope.filters.campaign,
                    optionsApi.isUseCdp()
                )
                .then(
                    function (res) {
                        var seriesdata = {
                            spend: [],
                            imps: [],
                            clicks: [],
                        };
                        var range = [];
                        $scope.trafficDetails = [];
                        $scope.totals = {spend: 0, imps: 0, clicks: 0};



                        //totals + deliveredCampaigns
                        var dates = [];
                        var limit = 10;
                        if (res.length > 0) {
                            for (var i = 0; i < res.length; i++) {
                                $scope.totals.spend += res[i].sum_cost / 1000000;
                                $scope.totals.imps += res[i].n_impression;
                                $scope.totals.clicks += res[i].n_click;

                                // Fill dates
                                if (dates[res[i].date]) {
                                    dates[res[i].date].sum_cost += res[i].sum_cost;
                                    dates[res[i].date].n_impression += res[i].n_impression;
                                    dates[res[i].date].n_click += res[i].n_click;
                                } else {
                                    dates[res[i].date] = {
                                        sum_cost: res[i].sum_cost,
                                        n_impression: res[i].n_impression,
                                        n_click: res[i].n_click
                                    };
                                }

                                // fill deliveredCampaigns
                                var cid = res[i].cid;
                                if ($scope.trafficDetails[cid]) {
                                    // console.log($scope.trafficDetails[cid]);
                                    $scope.trafficDetails[cid].stats.spend += res[i].sum_cost / 1000000;
                                    $scope.trafficDetails[cid].stats.imps += res[i].n_impression;
                                    $scope.trafficDetails[cid].stats.clicks += res[i].n_click;
                                    // console.log($scope.trafficDetails[cid]);
                                } else {
                                    $scope.trafficDetails[cid] = {
                                        io_id: $scope.campaignsData[cid].io_id,
                                        io_name: $scope.campaignsData[cid].io_name,
                                        name: $scope.campaignsData[cid].name,
                                        start: $scope.campaignsData[cid].start,
                                        end: $scope.campaignsData[cid].end,
                                        id: cid,
                                        stats: {
                                            spend: res[i].sum_cost / 1000000,
                                            imps: res[i].n_impression,
                                            clicks: res[i].n_click,
                                        },
                                    };
                                }
                            }

                            $scope.trafficDetails = Object.values($scope.trafficDetails).slice(0, limit);

                            //series
                            var filtersRange = $scope.filters.range;
                            var start = new Date(overviewApi.getDatesFromRange(filtersRange)['start'].getTime());
                            var end = new Date(overviewApi.getDatesFromRange(filtersRange)['end'].getTime());
                            for (;start.getTime() <= end.getTime(); start.setDate(start.getDate() + 1) ) {
                                var gDate = new Date(start.getTime()).toISOString().slice(0, 10);
                                var dt = gDate;
                                range.push(gDate);
                                if (!dates[dt]) {
                                    seriesdata.spend.push(0);
                                    seriesdata.imps.push(0);
                                    seriesdata.clicks.push(0);
                                } else {
                                    var spend = +(dates[dt].sum_cost / 1000000).toFixed(2);
                                    seriesdata.spend.push(spend);
                                    seriesdata.imps.push(dates[dt].n_impression);
                                    seriesdata.clicks.push(dates[dt].n_click);
                                }
                            }
                            // console.log(range, seriesdata);



                        }
                        generateSerial(range, seriesdata);
                        $scope.loading = false;
                    },
                    function () {
                        console.error('Error while fetching data');
                    }
                );
        } else {
            overviewApi
                .getTotals(
                    $scope.filters.range,
                    $scope.filters.advertiser,
                    $scope.filters.io,
                    $scope.filters.campaign
                )
                .then(
                    function (res) {
                        if (res.length > 0) {
                            $scope.totals = {
                                spend: res[0].sum_cost / 1000000,
                                imps: res[0].n_impression,
                                clicks: res[0].n_click,
                            };
                        } else {
                            $scope.totals = {spend: 0, imps: 0, clicks: 0};
                        }
                    },
                    function () {
                        console.error('Error while fetching data');
                    }
                );

            overviewApi
                .getDeliveredCampaigns(
                    $scope.filters.range,
                    $scope.filters.advertiser,
                    $scope.filters.io,
                    $scope.filters.campaign
                )
                .then(
                    function (res) {
                        $scope.trafficDetails = [];
                        if (res.length > 0) {
                            for (var i = 0; i < res.length; i++) {
                                $scope.trafficDetails.push({
                                    io_id: res[i].ref_insertion_order_id,
                                    io_name: res[i].io_name,
                                    name: res[i].campaign_name,
                                    start: res[i].campaign_start * 1000,
                                    end: res[i].campaign_end * 1000,
                                    id: res[i].cid,
                                    stats: {
                                        spend: res[i].sum_cost / 1000000,
                                        imps: res[i].n_impression,
                                        clicks: res[i].n_click,
                                    },
                                });
                            }
                        }
                    },
                    function () {
                        console.error('Error while fetching data');
                    }
                );

            overviewApi
                .getSeries(
                    $scope.filters.range,
                    $scope.filters.advertiser,
                    $scope.filters.io,
                    $scope.filters.campaign
                )
                .then(
                    function(res) {
                        var data = {
                            spend: [],
                            imps: [],
                            clicks: [],
                        };
                        var range = [];

                        var dates = [];
                        for (var i = 0; i < res.data.length; i++) {
                            if (res.data[i]['ref_date']){
                                dates[res.data[i]['ref_date']] = res.data[i];
                            } else {
                                dates[res.data[i]['userTimezoneDate']] = res.data[i];
                            }
                        }


                        var d = new Date(res.start);
                        var end = new Date(res.end);
                        for (;d.getTime() <= end.getTime(); d.setDate(d.getDate() + 1) ) {
                            var gDate = new Date(d.getTime()).toISOString().slice(0, 10);
                            var dt = yyyymmdd(new Date(gDate));
                            range.push(gDate);
                            if (!dates[dt]) {
                                data.spend.push(0);
                                data.imps.push(0);
                                data.clicks.push(0);
                            } else {
                                var spend = +(dates[dt]['sum_cost'] / 1000000).toFixed(2);
                                data.spend.push(spend);
                                data.imps.push(dates[dt]['n_impression']);
                                data.clicks.push(dates[dt]['n_click']);
                            }
                        }

                        generateSerial(range, data);
                        $scope.loading = false;
                    },
                    function() {
                        console.error('Error while fetching data');
                    }
                );

        }
        };


        $scope.fetchCreatives = function () {
            overviewApi
                .getDeliveredCreatives(
                    $scope.filters.range,
                    $scope.filters.advertiser,
                    $scope.filters.io,
                    $scope.filters.campaign,
                    $scope.creativesPage
                )
                .then(
                    function(data) {
                        $scope.creatives = {
                            count: data.count,
                            data: [],
                            maxPage: Math.floor(data.count / $scope.creativesPage.size),
                        };
                        if (data.count > 0) {
                            var res = data.data;
                            for (var i = 0; i < res.length; i++) {
                                $scope.creatives.data.push({
                                    id: res[i].ad,
                                    io_id: res[i].ref_insertion_order_id,
                                    io_name: res[i].io_name,
                                    campaign_id: res[i].cid,
                                    campaign_name: res[i].campaign_name,
                                    name: res[i].creative_name,
                                    type: res[i].creative_type,
                                    imps: res[i].n_impression,
                                    rate:
                                        res[i].n_impression > 0
                                            ? res[i].n_click / res[i].n_impression * 100
                                            : 0,
                                });
                            }
                        }
                    },
                    function() {
                        $scope.creatives = {
                            count: 0,
                            data: [],
                            maxPage: null,
                        };
                        console.error('Error while fetching data');
                    }
                );
        };



          $scope.setCreativesPage = function(page) {
              $scope.creativesPage.number = page;
              $scope.fetchCreatives();
          };




      var fetchPie = function(){
          if ($scope.showPie) {
              overviewApi
                  .getPies(
                      $scope.filters.range,
                      $scope.filters.advertiser,
                      $scope.filters.io,
                      $scope.filters.campaign
                  )
                  .then(
                      function (res) {
                          var pieImpData = [];
                          var pieClickData = [];
                          if (res.length > 0) {
                              for (var i = 0; i < res.length; i++) {
                                  if (res[i].dvt) {
                                      var name = res[i].dvt.charAt(0).toUpperCase() + res[i].dvt.slice(1);
                                      pieImpData.push({name: name, y: res[i].n_impression});
                                      pieClickData.push({name: name, y: res[i].n_click});
                                  }
                              }
                          }
                          generatePie(pieImpData, pieClickData);
                      },
                      function () {
                          console.error('Error while fetching data');
                      }
                  );
          }
      };

      $scope.$watch('showPie',function(newVal, oldVal) {
          fetchPie();
     },true);



      $scope.filters = {
        advertiser: '*',
        io: '*',
        campaign: ['*'],
        range: 'last_7_days',
      };

      if (preselectedCids && preselectedCids.length > 0){
          $scope.filters.campaign = preselectedCids;
      }

      $scope.$watch(
        'filters',
        function(newVal, oldVal) {
          if (newVal.range !== oldVal.range) {
            fetchData();
            return;
          }

          if (newVal.advertiser !== oldVal.advertiser) {
            $scope.filters.io = '*';
            $scope.filters.campaign = ['*'];
          }

          if (newVal.io !== oldVal.io) {
            $scope.filters.campaign = ['*'];
          }

          fetchFilterOptions();
        },
        true
      );
    },
  ]);

  generatePie = function(impData, clickData) {
    Highcharts.chart('pie-container', {
      exporting: { enabled: false },
      credits: { enabled: false },
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
        margin: [0, 0, 0, 0],
        height: $('#pie-container').width() - $('#pie-container').width() * 0.1,
      },
      title: {
        text: null,
      },
      tooltip: {
        pointFormat:
          '{series.name}: <b>{point.percentage:.1f}% ({point.y})</b>',
      },
      plotOptions: {
        pie: {
          allowPointSelect: false,
          shadow: false,
          center: ['50%', '50%'],
          dataLabels: {
            enabled: false,
          },
        },
      },
      series: [
        {
          name: 'Impressions',
          colorByPoint: true,
          innerSize: '80%',
          data: impData,
        },
        {
          name: 'Clicks',
          colorByPoint: true,
          innerSize: '59%',
          size: '60%',
          data: clickData,
        },
      ],
    });
  };

  generateSerial = function(categories, data) {
    if (document.getElementById("serial-container") === null) {
        return;
    }
    Highcharts.chart('serial-container', {
      exporting: { enabled: false },
      credits: { enabled: false },
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,

        height: '250px',
      },
      title: {
        text: null,
      },
      xAxis: {
        categories: categories,
      },
      yAxis: [
        {
          title: {
            text: 'Clicks / Impressions',
          },          
        },
        {
          opposite: true,
          title: {
            text: 'Spendings (€)',
          },
        },
      ],
      legend: {
        enabled: true,
      },

      plotOptions: {
        areaspline: {
          marker: {
            enabled: false,
          },
        },
      },

      series: [
        {
          name: 'Spendings',
          data: data.spend,
          yAxis: 1,
          color: '#2D83BC',
          type: 'areaspline',
          visible: false,
        },
        {
          name: 'Impressions',
          data: data.imps,
          type: 'column',
          color: '#e2861e',
        },
        {
          name: 'Clicks',
          data: data.clicks,
          type: 'column',
          color: '#15907C',
          visible: false,
        },
      ],

      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 500,
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom',
              },
            },
          },
        ],
      },
    });
  };
})(window.angular);
